'use client';
import clsx from 'clsx';
import { Button } from '../../../Button';
import { useDropdownContext } from '../../../DropdownProvider';
import {
  CLOSE_MY_NERDWALLET_MENU_ACTION,
  OPEN_MY_NERDWALLET_MENU_ACTION,
} from '../../../DropdownProvider/useSingleDropdown';
import { ProfileAvatar } from '../../../Icons/ProfileAvatar';
import {
  AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
  AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
} from '../constants';

export function MyNerdWalletButtonMobile() {
  const {
    state: {
      myNerdWalletMenu: { isOpen },
    },
    dispatch,
  } = useDropdownContext();

  const handleToggleMenu = () => {
    if (isOpen) {
      dispatch(CLOSE_MY_NERDWALLET_MENU_ACTION);
    } else {
      dispatch(OPEN_MY_NERDWALLET_MENU_ACTION('mobile'));
    }
  };

  return (
    <div
      className={clsx(
        AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
        AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
        'flex',
        'sm:hidden',
      )}
    >
      <Button
        className={clsx(
          'w-full',
          'flex',
          'items-center',
          'justify-end',
          'xs:justify-center',
          'gap-2',
          'rounded-full',
          '!text-black',
          'tap-transparent',
          {
            'bg-green-lightest': isOpen,
          },
        )}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-controls="satellite-my-nerdwallet-dropdown"
        variant="plain"
        onClick={handleToggleMenu}
        icon={<ProfileAvatar className="w-8 h-8 xs:w-6 xs:h-6" />}
        typographyClassname="hidden xs:block"
      >
        My NerdWallet
      </Button>
    </div>
  );
}
